import { Component, OnInit, Inject } from '@angular/core';
import {Router} from "@angular/router"
import { SESSION_STORAGE, StorageService } from 'ngx-webstorage-service';
import { HttpClient, HttpHeaders, HttpParams, HttpResponse, HttpErrorResponse} from '@angular/common/http';
import { MatDialog} from '@angular/material/dialog';
import { environment } from '../../../environments/environment';
import { DlgTrabajandoComponent } from '../../components/dlg-trabajando/dlg-trabajando.component';
import { DlgErrorComponent } from '../../components/dlg-error/dlg-error.component';
import {MatDialogRef} from '@angular/material/dialog';
import { DlgAvisoComponent } from '../../components/dlg-aviso/dlg-aviso.component';
import { DlgBusquedasComponent } from '../../components/dlg-busquedas/dlg-busquedas.component';

@Component({
  selector: 'app-dlg-mails',
  templateUrl: './dlg-mails.component.html',
  styleUrls: ['./dlg-mails.component.css']
})
export class DlgMailsComponent implements OnInit {

  titulo="";
  txtTipoMail="";
  idTipoMail="";
  nombreTipoMail="";
  idMail="";
  txtMail="";

  constructor(
    private router: Router,
    public dialog: MatDialog,
    private httpClient: HttpClient,
    @Inject(SESSION_STORAGE) private storage: StorageService,
    public thisDialogRef: MatDialogRef<DlgMailsComponent>,
  ) { }

  ngOnInit(): void {
  }

  cerrarDialogo(dialogoActual) {
    dialogoActual.close();
  }

  cerrar(cadena) {
    this.thisDialogRef.close({mensaje: cadena, idMail: this.idMail
      ,idTipoMail: this.idTipoMail
      ,nombreTipoMail: this.nombreTipoMail
      ,txtMail: this.txtMail
    });
  }

  buscarTipoMail(){
    let dlgBusquedas = this.dialog.open(DlgBusquedasComponent, {
      width: window.innerWidth.toString()+"px",
      disableClose:true
    });
    dlgBusquedas.componentInstance.lblTitBusqueda="Tipo de mail:";
    dlgBusquedas.componentInstance.codBusqueda="TIPOMAIL";
    dlgBusquedas.componentInstance.txtBusc=this.txtTipoMail;
    dlgBusquedas.afterClosed().subscribe(
      data => {
        if (data.idTipoMail!=null){
          this.idTipoMail=data.idTipoMail;
          this.nombreTipoMail=data.nombre;
        }
      }
    );
  }

  eliminarTipoMail(){
    this.idTipoMail="";
    this.nombreTipoMail="";
  }

  almacenar(){
    if (this.nombreTipoMail==""){
      let dlgError = this.dialog.open(DlgErrorComponent, {
        width: '600px',
        disableClose:true
      });
      dlgError.componentInstance.titulo="Error al almacenar el mail";
      dlgError.componentInstance.texto="Le falto indicar el tipo mail";
      return;
    }
    if (this.txtMail==""){
      let dlgError = this.dialog.open(DlgErrorComponent, {
        width: '600px',
        disableClose:true
      });
      dlgError.componentInstance.titulo="Error al almacenar el mail";
      dlgError.componentInstance.texto="Le falto indicar el mail";
      return;
    }
    this.cerrar('almaceno');
  }
}
